import React from 'react'
import styled, { keyframes, StyledProps } from 'styled-components'
import { Flag } from '../../misc/Flag/Flag'
import { Button } from '../../buttons/Button/Button'
import { Spinner } from '../../misc/Spinner/Spinner'

type ThemedProps = StyledProps<{}>

export const TableComponentsWrapper = styled.div`
  display: grid;
  grid-template-rows: ${(props: { noFilters?: boolean }) =>
    props.noFilters ? 'auto max-content' : 'max-content auto max-content'};
  height: 100%;
  overflow: hidden;
`

export const TableComponentsFilters = styled.div`
  position: sticky;
  top: 0;
  border-top: ${({ theme }: ThemedProps) => `1px solid ${theme.color.outlineMid}`};
  background-color: ${({ theme }: ThemedProps) => theme.color.onPrimaryLight};
  display: flex;
  padding: 12px 36px 16px;
  z-index: 1;
`

export const TableComponentsFlag = styled(Flag)`
  margin-right: 5px;
`

const appear = keyframes`
  to {
    opacity: 1;
  }
`

export const TableComponentsSpinnerWrapper = styled.div`
  margin: 20px auto;
  display: flex;
  justify-content: center;
  opacity: 0;
  animation: ${appear} 0.3s;
  animation-fill-mode: forwards;
  animation-delay: 0.3s;
`

export const TableComponentsSpinner = () => {
  return (
    <TableComponentsSpinnerWrapper>
      <Spinner />
    </TableComponentsSpinnerWrapper>
  )
}

export const TableComponentsSummaryWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin-right: 24px;
`

export const TableComponentsSummaryTitle = styled.span`
  display: flex;
  justify-self: flex-start;
  margin-left: 0;
  margin-right: 24px;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: ${({ theme }) => theme.color.onPrimaryDark};
`

export const TableComponentsSummaryLabel = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin-right: 8px;
  color: ${props => props.theme.color.onPrimaryDark};
`

export const TableComponentsCheckboxWrapper = styled.div`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: max-content auto;
`

export const TableComponentsClearButton = styled(Button)`
  margin-top: 20px;
`

export const TableComponentsLinkButton = styled.div`
  justify-self: flex-start;
  margin-left: 0;
  margin-right: auto;

  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  color: ${props => props.theme.color.primary600};

  cursor: pointer;
`

export const TableComponentsActionButton = styled(Button)`
  margin-right: 16px;
`
